<template>
    <div class="layout">
        <Layout  style="height:100%">
            <Header style="height:60px;background: #232730;padding-left:25px;">
                <a class="scroll_navigation_logo_a" href="/">
                    <img src="../../../static/images/logo2.png" class="scroll_navigation_img"/>
                </a>
            </Header>
            <Layout class="center" style="width:100%;">
                <div v-if="BarShow" style="">
                    <Sider class="left" width="50">
                        <Left :selectMenu="selectMenu" :current="current"></Left>
                    </Sider>
                    <Sider class="right" width="250" v-if="contest_id > 0">
                        <component :is="current" :contestInfo="contestInfo" :tree_list="tree_list" :tree_click="TreeClick" style="margin-left:5px;"></component>
                    </Sider>
                </div>
                <div class="sidebar-toggle-button" @click="changeTool">
                    <Icon :type="iconType" size="30" color="rgb(45, 140, 240)"/>
                </div>
                <Content>
                    <component :is="currentView" :labId="readyLabId" :fileUuid = 'contestInfo.code_info.file_uuid' :contestInfo="contestInfo" :treeListFunc="paramsTreeList" v-if="contestInfo.id > 0"></component>
                </Content>
            </Layout>
        </Layout>
        <!--  销毁提示-->
        <Modal
                v-model="destructShow"
                title="容器销毁提示"
                @on-ok="ok">
            <p style="font-size: 16px">环境容器已删除!</p>
        </Modal>
    </div>
</template>
<script>
    import {mapActions} from "vuex";
    import Left from "./run/left"
    import Directory from "./run/components/directory"
    import Data from "./run/components/data"
    import Jupyter from '@/components/jupyter/jupyter'

    export default {
        name: "run",
        components: {
            Left,
            Directory,
            Data,
            Jupyter
        },
        data: () => {
            return {
                currentView:"Jupyter",
                destructShow:false,
                contestInfo:{
                    id:0,
                    datasets_info:[],
                    mcp_endpoint:{
                        domain_name:'',
                    }
                },
                endTime:'',
                readyBaseUrl:'',
                readyLabId:0,
                contest_id:0,
                file_uuid:'',
                tree_list:[],
                BarShow: true,
                current: "Data",
                iconType: "ios-arrow-back",
                isConnect:false,
                // notebook
                runColor:"gray",
                kernelName:"",
                showHeader:false,
                cmNbManager:{},
                cellType:"",
                cellTypeList:[],
            }
        },
        methods: {
            ...mapActions({
                getContestInfo:"contest/getContestInfo",
                CreateContainer:"container/CreateContainer",
                QueryContainer:"container/QueryContainer",
                Heartbeat:"container/Heartbeat",
            }),
            selectMenu(data) {
                this.current = data
            },
            changeTool() {
                this.changeJpCss();
                this.BarShow = !this.BarShow;
                this.iconType = this.iconType == "ios-arrow-back" ? "ios-arrow-forward" : "ios-arrow-back"
            },
            changeJpCss(){
                if(document.createEvent) {
                    var event = document.createEvent("HTMLEvents");
                    event.initEvent("resize", true, true);
                    window.dispatchEvent(event);
                } else if(document.createEventObject) {
                    window.fireEvent("onresize");
                }
            },
            paramsTreeList(value){
                var copy = value;
                let level = 0;
                let res = [];
                let tmpItem = [];
                let partent = [];
                copy.forEach((item)=>{
                    item.title = item.text;
                    item.callFunc = item.onClick;
                    item.children = [];
                    if(level === 0){
                        res.push(item)
                        tmpItem  = item;
                        partent  = res;
                        partent.chindren = [];
                        level = item.level;
                    }else if(item.level === level){
                        partent.push(item)
                        tmpItem = item;
                    }else if(item.level > level){
                        tmpItem.children.push(item);
                        partent = tmpItem.children;
                        tmpItem = item;
                        level = item.level;
                    }else{
                        res.push(item);
                        partent = res;
                        tmpItem = item;
                        level = item.level;
                    }


                })
                this.tree_list = res
            },
            TreeClick(value){
                if(value.length == 1){
                    value[0].callFunc();
                }
            },
            // 获取竞赛详细信息
            getContestInfoVuex(){
                let _this = this;
                this.getContestInfo({
                    id:_this.contest_id,
                    callback:res=>{
                        _this.contestInfo = res;
                        // _this.createContainer();
                    },
                    error:msg=>{
                        _this.$Message.error(msg);
                        _this.$router.push({
                            name:"lists"
                        })
                    }
                })
            },
            ok(){
                window.close();
            }
        },
        mounted(){
            var _this = this;
            _this.file_uuid = this.$route.params.file_uuid;
            _this.contest_id = parseInt(this.$route.params.contest_id);
            if(_this.file_uuid === '' || _this.contest_id === 0){
                _this.$router.push({
                    name:"lists"
                })
            }

            this.getContestInfoVuex();
        }
    }
</script>


<style scoped>
    .layout {
        width: 100%;
        height: 100%;
    }

    .full-screen-container .fs-left-panel a {
        font-size: 14px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 75px;
        border-left: 4px solid transparent;
        transition: border-color .5s ease, background-color .5s ease;
        color: #828a92;
        background-color: transparent;
    }

    .center {
        padding-top: 5px;
    }

    .left {
        height: 100%;
        background: #f2f2f2;
        float: left;
        display: inline;
    }

    .right {
        height: 100%;
        float: left;
        background: #f9fafa;
        display: inline;
    }

    .scroll_navigation_logo_a {
        display: block;
        border: 0;
        height: 60px;
        line-height: 54px;
    }

    .scroll_navigation_img {
        height: 32px;
        width: 220px;
    }


    .sidebar-toggle-button .ivu-icon {
        transition: transform .3s ease;
        line-height: 46px;
        font-size: 24px;
        color: #99a3af;
    }

    .sidebar-toggle-button {
        position: absolute;
        z-index: 16;
        border-bottom-right-radius: 8px;
        border-top-right-radius: 8px;
        left: 0;
        top: 45vh;
        text-align: center;
        width: 28px;
        height: 46px;
        cursor: pointer;
        transition: width .3s ease;
        background: #fff;
        box-shadow: 0 1px 3px #ddd;
    }
</style>
